<template>
  <div class="sv sv006">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-blue" src="sv008/main.jpg">
        <p class="heading1">教えて！みんなのローン活用術</p>
        <h1 class="heading2">急な飲み会･･･<br />給料日前だけど参加したい！</h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-blue _pt-sm-60"
        icon-left="sv008/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv008/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同期の2人"
      >
        AさんとBさんは社会人４年目で同じ部署に所属する同期です。部署の飲み会幹事はいつも2人が担当しています。<br />
        今回は、予定していた歓迎会の日程が急きょ前倒しになり会費の支払いがピンチに！
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <TalkGroup>
        <TalkBox src="sv008/avatar-a.gif"
          >俺たちが来週企画してた新人歓迎会だけど、部長が急きょ明後日から出張になっちゃって、明日に前倒しにしてほしいって！</TalkBox
        >
        <TalkBox src="sv008/avatar-b.gif"
          >えぇっ、給料日前なのに…。メンバーの予定は大丈夫そうだけど、会費がきついな</TalkBox
        >
        <TalkBox src="sv008/avatar-a.gif"
          >そうだよなあ。先週の送別会も、若手は厳しいって言うから俺が立て替えてるままだよ。</TalkBox
        >
        <TalkBox src="sv008/avatar-b.gif"
          >俺すでに今月ピンチ…。ちょっと生活費の支払いが危うくなってきそう。困ったなあ…</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >毎回の立て替えでお金がなくてピンチ…<br
          class="-pcnone"
        />こんなときどうする？</HeadingTwo
      >

      <TalkGroup class="_mb-120 _mb-sm-50">
        <TalkBox src="sv008/avatar-b.gif"
          >せっかくの新人歓迎会だからみんなに参加してほしいし、会費が払えないからって不参加になるのは嫌だもんな</TalkBox
        >
        <TalkBox src="sv008/avatar-a.gif"
          >こうなったら、またちょっと借りるしかないな</TalkBox
        >
        <TalkBox src="sv008/avatar-b.gif">借りる？誰にだよ？笑</TalkBox>
        <TalkBox src="sv008/avatar-a.gif"
          >違うよ、『au PAY
          スマートローン』で借りるんだよ！スマートフォンで便利に使えるローンサービスだよ</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-blue _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-blue" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading">
            au PAY スマートローンなら<br class="-pcnone" />こんなに便利！
          </h3>
        </div>
        <div class="card-body01">
          <p class="txt01">
            ご利用限度額は、１万円~100万円（※）まで。カードレスでご利用はすべてスマートフォンで完結するのでとっても便利！
          </p>
          <ListGroup class="-note">
            <ListItem class="-note -textcenter _mb-25"
              >実際のご契約条件は、お申し込み後の審査に基づきご提示させていただきます。
            </ListItem>
          </ListGroup>
          <div class="card-groups">
            <div class="card-box">
              <div class="card-image -width90">
                <img
                  src="@/assets/images/sv/sv008/img01.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                お借り入れは1万円から！一時的にお金が足りないときに頼れる味方です。
              </div>
            </div>
            <div class="card-box">
              <div class="card-image -width80">
                <img
                  src="@/assets/images/sv/sv008/img02.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                スマートフォンがあれば、新規お申し込みもお借り入れもかんたんWEB完結！
              </div>
            </div>
            <div class="card-box">
              <div class="card-image -width80">
                <img
                  src="@/assets/images/sv/sv001/img07.gif"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                au PAY 残高にそのままチャージができます。チャージした残高は、au
                PAY プリペイドカードやau
                PAYで全国のコンビニ・スーパーやMastercard®加盟店、au
                PAY加盟店などいろいろな場所で使え、Pontaポイントもたまります。
              </div>
            </div>
          </div>
        </div>
      </ContentsCard>

      <TalkGroup class="_mb-120 _mb-sm-50">
        <TalkBox src="sv008/avatar-b.gif"
          >飲み会の費用って立て替え含めて２~３万だよな？そんな小額でも借りられるの？</TalkBox
        >
        <TalkBox src="sv008/avatar-a.gif"
          >au PAY
          スマートローンは１万円から借りることができるよ。飲み会費用を精算したらすぐにまとめて返せば利息もそこまでかからないし</TalkBox
        >
        <TalkBox src="sv008/avatar-b.gif"
          >こんなサービスがあったんだな！でもさ、飲み会明日だよな？</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >すぐにお金がほしいときでも大丈夫！</HeadingTwo
      >

      <TalkGroup class="_mb-120 _mb-sm-50">
        <TalkBox src="sv008/avatar-a.gif"
          >au PAY
          スマートローンは、専用アプリがあればセブン銀行ATMで現金で受け取ることができるんだ</TalkBox
        >
        <TalkBox src="sv008/avatar-b.gif"
          >セブン銀行ATMは、飲み会に行く途中にもあるな！</TalkBox
        >
        <TalkBox src="sv008/avatar-a.gif"
          >あとは、au PAY 残高にチャージすることもできるんだ！</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-blue _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-blue" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading">
            au PAY 残高にチャージすれば<br
              class="-pcnone"
            />スマートにおトクに使える！
          </h3>
        </div>
        <div class="card-body02">
          <p class="txt01">
            スマートフォンがあれば、どこにいても借り入れが可能です！通勤途中やお昼休みなどのちょっとした時間でお手続きが完了します！
          </p>
          <div class="card-groups">
            <div class="card-box -width70 _mb-sm-20">
              <div class="card-body">
                <ListGroup class="-normal">
                  <ListItem class="-normal"
                    >au PAY 残高にすぐにチャージができます！</ListItem
                  >
                  <ListItem class="-normal"
                    >チャージした残高は、au PAY プリペイドカードやau
                    PAYで使えます。</ListItem
                  >
                  <ListItem class="-normal"
                    >全国のコンビニ・スーパーやMastercard®加盟店、au
                    PAY加盟店などいろいろな場所で使えます。</ListItem
                  >
                  <ListItem class="-normal"
                  >ご利用額200円（税込）ごとに１Pontaポイントがたまります。</ListItem
                  >
                </ListGroup>
              </div>
            </div>
            <div class="card-box">
              <div class="card-image">
                <img
                  src="@/assets/images/sv/sv001/img07.gif"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </ContentsCard>

      <TalkGroup class="_mb-120 _mb-sm-50">
        <TalkBox src="sv008/avatar-b.gif"
          >それならコンビニに寄る時間がないときにも使えるし、飲み会中にお金が足りないって気付いたときでも、その場でチャージできるな！</TalkBox
        >
        <TalkBox src="sv008/avatar-a.gif"
          >au PAY 残高にチャージすれば、au PAY プリペイドカードやau
          PAYで使えるし、Pontaポイントもたまるからさらにおトクなんだ</TalkBox
        >
        <TalkBox src="sv008/avatar-b.gif"
          >ローンって、住宅とか車とかの高い買い物で使うイメージだったからハードルが高い気がしてたけど、今回みたいに会費が少し足りないってときにも頼れそうだな</TalkBox
        >
        <TalkBox src="sv008/avatar-a.gif"
          >借りた分の利息はかかるけど、返せるあてがあるお金をさっと用意できるのはメリットだよ。Bさんも調べてみるといいよ</TalkBox
        >
        <ListGroup class="-note">
          <ListItem class="-note"
            >au PAY
            スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
          >
        </ListGroup>
      </TalkGroup>

      <div class="container _mb-md-120 _mb-sm-60">
        <BtngroupSingle>
          <BtnMain class="-normal -lg" router-name="sv002"
            >au PAY スマートローンの特徴について</BtnMain
          >
        </BtngroupSingle>
      </div>
      <CvBox class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv006" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv006/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">結婚＆出産…お祝いは突然やってくる？</h3>
          </CardHeader>
          <CardBody
            >「お祝い」続きで資金不足に…せっかくのお祝いを諦める？</CardBody
          >
        </CardBox>

        <CardBox router-name="sv007" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv007/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">せっかくの卒業旅行…お金のことで諦めないで！</h3>
          </CardHeader>
          <CardBody
            >楽しいはずの旅行…お金の都合で妥協したり、諦めかけたことってありませんか？</CardBody
          >
        </CardBox>

        <CardBox router-name="sv053" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv053/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">"ちょっとだけ"がすごく助かる生活の工夫</h3>
          </CardHeader>
          <CardBody
            >ローンの借り入れ理由として多いのが、実は「日々の生活費」なんです！</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";

export default {
  name: "Sv008",
  components: {
    BreadcrumbGroup,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    HeadingTwo,
    TalkBox,
    TalkGroup,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "急な飲み会･･･給料日前だけど参加したい！｜教えて！みんなのローン活用術",
      description:
        "みんなのローンの活用術！急な飲み会で必要なときに。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,給料日前,飲み会",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "教えて！みんなのローン活用術",
          routerName: "sv042",
        },
        {
          text: "急な飲み会･･･給料日前だけど参加したい！",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body01 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px;
      padding-right: 50px;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 0px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          width: 30%;
        }
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
      }
    }
  }
}

.contents-card {
  > .card-body02 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px;
      padding-right: 50px;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 25px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          width: 30%;
        }
        &.-width70 {
          @include mq-up(md) {
            width: 70%;
          }
        }
        > .card-image {
          margin: 0 auto 20px;
          max-width: 62%;
          @include mq-up(md) {
            max-width: 204px;
          }
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
      }
    }
  }
}
</style>
